const centralLevelServices = {
  MonthlyPayment: 1,
  Books: 2,
  Enrollment: 3,
  Thrapy: 4,
  Others: 5,
  ServiceAssistant: 6,
  SpeechTherapy: 7,
  OccupationalTherapy: 8,
  psychologicalTherapy: 9,
  ABATherapy: 10,
  OromotorTherapy: 11,
  Physicaltherapy: 12,
  EducationalTherapy: 13,
  Quote: 14,
  Lunch: 15
};

export default centralLevelServices;

